import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';
import { autoUpdateSessionStorage, reactivityFix } from '@/apps/order/helper';
import { useRouterStore } from '@/apps/order/stores';
import { CustomFieldRequiredBySourceType } from '@/apps/order/interfaces/CustomFieldValuesInterface';

const useOrdersCreateCustomFieldsStore = defineStore('ordersCreateCustomFields', () => {
  const routerStore = useRouterStore();
  const { meta } = storeToRefs(routerStore);

  const customFieldRequiredBySource = ref<CustomFieldRequiredBySourceType>({});
  reactivityFix(customFieldRequiredBySource);
  autoUpdateSessionStorage(
    `${meta.value.ctx}.customFieldRequiredBySource`,
    () => customFieldRequiredBySource.value,
    1000,
  );

  const getRequiredFieldsFlat = (productId: number | string): string[] => (
    Object.values(customFieldRequiredBySource.value[`${productId}`] || {}).flat()
  );

  const isFieldRequiredOverride = (productId: number | string, fieldKey: string): boolean => (
    getRequiredFieldsFlat(productId).includes(fieldKey)
  );

  const setRequiredFieldsForSource = (productId: number | string, sourceKey: string, keys: string[]): void => {
    const pid = `${productId}`;
    customFieldRequiredBySource.value = {
      ...customFieldRequiredBySource.value,
      [pid]: {
        ...(customFieldRequiredBySource.value[pid] || {}),
        [sourceKey]: keys,
      },
    };
  };

  const clearRequiredFieldsForSource = (productId: number | string, sourceKey: string): void => {
    const pid = `${productId}`;
    const current = { ...(customFieldRequiredBySource.value[pid] || {}) } as Record<string, string[]>;
    delete current[sourceKey];
    customFieldRequiredBySource.value = {
      ...customFieldRequiredBySource.value,
      [pid]: current,
    };
  };

  return {
    customFieldRequiredBySource,
    getRequiredFieldsFlat,
    isFieldRequiredOverride,
    setRequiredFieldsForSource,
    clearRequiredFieldsForSource,
  };
});

export default useOrdersCreateCustomFieldsStore;
